export class CalcalistArticleRailStickyHost extends React.Component<{}, {}> {
    public static siteScriptName = "CalcalistArticleRailStickyHost"

    private resizeObserver: any
    private railEl: HTMLElement
    private observedHeader: HTMLElement
    private observedBody: HTMLElement

    componentDidMount() {
        this.railEl = document.getElementById("calcalistArticleRail")
        this.updateStickyLayout()
        this.observeTargets()
        window.addEventListener("resize", this.updateStickyLayout, false)
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.updateStickyLayout, false)
        if (this.resizeObserver) {
            this.resizeObserver.disconnect()
            this.resizeObserver = null
        }
    }

    private getScrollY = () => {
        return window.pageYOffset || (document.documentElement && document.documentElement.scrollTop) || 0
    }

    private getDocumentTop = (el: HTMLElement): number => {
        return el.getBoundingClientRect().top + this.getScrollY()
    }

    private getDocumentBottom = (el: HTMLElement): number => {
        return el.getBoundingClientRect().bottom + this.getScrollY()
    }

    private getArticleHeaderEl = (): HTMLElement => {
        return document.getElementById("calcalistArticleHeaderV2")
            || document.getElementById("calcalistArticleHeader")
            || document.querySelector(".calcalist-article-header-v2") as HTMLElement
            || document.querySelector(".calcalistArticleHeader") as HTMLElement
    }

    private getArticleBodyEl = (): HTMLElement => {
        return document.getElementById("ArticleBodyComponent")
            || document.getElementById("calcalistArticleBodyV2")
            || document.getElementById("calcalistArticleComponenta")
    }

    private getRailColumn = (rail: HTMLElement): HTMLElement => {
        let node = rail.parentElement
        while (node) {
            const className = node.className ? String(node.className) : ""
            if (className.indexOf("dynamicHeightItemsColumn") >= 0) {
                return node
            }
            node = node.parentElement
        }
        return rail.parentElement
    }

    private getColumnStretchBottom = (column: HTMLElement): number => {
        if (!column || !column.parentElement) {
            return 0
        }
        const siblings = column.parentElement.children
        let maxBottom = 0
        for (let i = 0; i < siblings.length; i++) {
            const sibling = siblings[i] as HTMLElement
            const bottom = this.getDocumentBottom(sibling)
            if (bottom > maxBottom) {
                maxBottom = bottom
            }
        }
        return maxBottom
    }

    private updateStickyOffsets = (rail: HTMLElement) => {
        const stickyHead = rail.querySelector(".calcalistArticleRailStickyHead") as HTMLElement
        const hotStories = rail.querySelector(".calcalistArticleRailHotStories") as HTMLElement
        const tags = rail.querySelector(".calcalistArticleRailTags") as HTMLElement
        const headHeight = stickyHead ? stickyHead.offsetHeight : 0
        const headTop = stickyHead ? (parseFloat(window.getComputedStyle(stickyHead).top) || 0) : 0
        const stickyTop = Math.round(headTop + headHeight) + "px"

        if (hotStories) {
            hotStories.style.top = stickyTop
        }
        if (tags) {
            tags.style.top = stickyTop
        }
    }

    private updateRailHeight = (rail: HTMLElement) => {
        const header = this.getArticleHeaderEl()
        const body = this.getArticleBodyEl()
        const column = this.getRailColumn(rail)
        const columnTop = column ? this.getDocumentTop(column) : this.getDocumentTop(rail)
        const headerTop = header ? this.getDocumentTop(header) : columnTop
        const stretchTop = headerTop < columnTop ? headerTop : columnTop
        let stretchBottom = 0

        if (body) {
            stretchBottom = this.getDocumentBottom(body)
        } else if (column) {
            stretchBottom = this.getColumnStretchBottom(column)
        } else if (header) {
            stretchBottom = this.getDocumentBottom(header)
        }

        const pullUp = columnTop > stretchTop ? columnTop - stretchTop : 0
        const nextHeight = stretchBottom - stretchTop

        rail.style.marginTop = pullUp > 0 ? (-Math.round(pullUp)) + "px" : ""
        if (nextHeight > 0) {
            rail.style.minHeight = Math.round(nextHeight) + "px"
        }
        if (column && pullUp > 0) {
            column.style.overflow = "visible"
        }

        this.observeArticleTargets()
    }

    private updateStickyLayout = () => {
        const rail = this.railEl || document.getElementById("calcalistArticleRail")
        if (!rail) {
            return
        }
        this.railEl = rail
        this.updateStickyOffsets(rail)
        this.updateRailHeight(rail)
    }

    private observeArticleTargets = () => {
        if (!this.resizeObserver) {
            return
        }
        const header = this.getArticleHeaderEl()
        if (header && header !== this.observedHeader) {
            this.resizeObserver.observe(header)
            this.observedHeader = header
        }
        const body = this.getArticleBodyEl()
        if (body && body !== this.observedBody) {
            this.resizeObserver.observe(body)
            this.observedBody = body
        }
    }

    private observeTargets = () => {
        const ResizeObserverCtor = (window as any).ResizeObserver
        if (!ResizeObserverCtor) {
            return
        }
        this.resizeObserver = new ResizeObserverCtor(this.updateStickyLayout)
        this.observeArticleTargets()
        if (this.railEl) {
            this.resizeObserver.observe(this.railEl)
            const stickyHead = this.railEl.querySelector(".calcalistArticleRailStickyHead")
            const hotStories = this.railEl.querySelector(".calcalistArticleRailHotStories")
            const tags = this.railEl.querySelector(".calcalistArticleRailTags")
            if (stickyHead) {
                this.resizeObserver.observe(stickyHead)
            }
            if (hotStories) {
                this.resizeObserver.observe(hotStories)
            }
            if (tags) {
                this.resizeObserver.observe(tags)
            }
            const column = this.getRailColumn(this.railEl)
            if (column) {
                this.resizeObserver.observe(column)
            }
            if (this.railEl.parentElement && this.railEl.parentElement !== column) {
                this.resizeObserver.observe(this.railEl.parentElement)
            }
        }
    }

    render() {
        return null
    }
}
